import { synUtil } from "../../../../javascript/Utilities";
import { AjaxSolr } from "../../core/Core.js";
import { getGroupingOptions } from "../../core/synerisSolrBase.js";

(function ($) {
    AjaxSolr.SynerisFacetWidget = AjaxSolr.AbstractFacetWidget.extend({
        constructor: function (attributes) {
            AjaxSolr.SynerisFacetWidget.__super__.constructor.apply(this, arguments);
            AjaxSolr.extend(this, {
                collapseAfter: 10,
                options: undefined
            }, attributes);

            this.groupingOptions = getGroupingOptions(this.field, this.options);
        },
        clearUI: function () {
            $(this.target).children("ul.facetList").remove();
        },
        beforeRequest: function () {
            this.clearUI();
            $(this.target).addClass("baseWidget")
                .addClass("facetWidget")
                .append($("<img style='display:block;margin:auto' src='assets/images/loading_image.gif' class='synAjaxLoad_animation' />"));
        },
        afterRequest: function () {
            let tgt = $(this.target);
            if (!this.manager.response.facet_counts || this.manager.response.facet_counts.facet_fields[this.field] == undefined) {
                tgt.html("");
                return;
            }
            let hasMore = this.manager.response.hasMore || false;

            let self = this;
            let maxCount = 0;
            let objectedItems = [];

            let groupedFacets = {};

            for (let facet in this.manager.response.facet_counts.facet_fields[this.field]) {
                if (!facet)
                    continue;

                let count = parseInt(this.manager.response.facet_counts.facet_fields[this.field][facet]);
                if (count > maxCount)
                    maxCount = count;

                let grouped = false;
                for (let i = 0; i < self.groupingOptions.length; i++) {
                    let groupingOption = self.groupingOptions[i];
                    if (groupingOption.regex.test(facet)) {
                        let facetTitle = synUtil.Strings.getValue(groupingOption.textKey);
                        if (facetTitle === groupingOption.textKey)
                            facetTitle = groupingOption.defaultText || facetTitle;

                        if (!groupedFacets[groupingOption.textKey]) {
                            groupedFacets[groupingOption.textKey] = {
                                facet: facetTitle,
                                count: 0,
                                regex: groupingOption.regex.source
                            };
                        }

                        groupedFacets[groupingOption.textKey].count += count;

                        grouped = true;
                        break;
                    }
                }

                if (!grouped)
                    objectedItems.push({ facet: facet, count: count });
            }
            for (let key in groupedFacets) {
                if (groupedFacets.hasOwnProperty(key))
                    objectedItems.push(groupedFacets[key]);
            }

            let max = 0;
            $.each(objectedItems, function (idx, item) { max = Math.max(max, item.count); });

            let showBars = !hasMore && objectedItems.length > 1;

            tgt.empty();
            let ul = $("<ul class='facetList'></ul>").appendTo(tgt);
            for (let i = 0, l = objectedItems.length; i < l; i++) {
                let barRight = (objectedItems[i].count / max) * 95;
                let facet = objectedItems[i].facet;
                let facetValue = facet;
                let noEscape = false;
                if (objectedItems[i].regex) {
                    facetValue = "/" + objectedItems[i].regex + "/";
                    noEscape = true;
                }
                let listItem = $("<li  style='position:relative'><strong>" + facet + (hasMore ? "</strong>" : ":</strong> " + objectedItems[i].count) + "</li>")
                    .off("click").on("click", this.clickHandler(facetValue, noEscape))
                    .hover(function () { $(this).addClass("k-state-hover"); },
                        function () { $(this).removeClass("k-state-hover"); });

                if (objectedItems[i].regex)
                    listItem.attr("data-regex", escape(objectedItems[i].regex));

                if (showBars)
                    listItem.append($("<div class='percentBar' style='width:" + barRight + "%'></div>"));

                ul.append(listItem);
            }
            let listItems = ul.children("li");
            if (this.collapseAfter > 0 && listItems.length > this.collapseAfter) {

                let clickHandler = function () {
                    let $this = $(this);
                    $this.unbind("click", clickHandler);
                    let li = $this.parent();
                    let containerDiv = li.parent().children("div.container");
                    let ul = li.parent();
                    if (containerDiv.css("display") === "none") {
                        $this.children(".k-icon").removeClass("k-i-arrowhead-s").addClass("k-i-arrowhead-n");
                        $this.children(".expandText").html(synUtil.Strings.getValue("less", "Less"));
                        containerDiv.css("display", "");
                        ul.append(li);
                    } else {
                        $this.children(".k-icon").removeClass("k-i-arrowhead-n").addClass("k-i-arrowhead-s");
                        $this.children(".expandText").html(synUtil.Strings.getValue("more", "More"));
                        li.insertBefore(containerDiv);
                        containerDiv.css("display", "none");
                    }
                    $this.bind("click", clickHandler);
                }

                let sliced = listItems.slice(this.collapseAfter);

                let liContainer = $("<li class='expanderWrap'></li>").appendTo(ul);
                $("<a class='expander' href='javascript:;'><span class='k-icon k-i-arrowhead-s'></span><span class='expandText'>" + synUtil.Strings.getValue("more", "More") + "</span></a>")
                    .bind("click", clickHandler)
                    .appendTo(liContainer);
                let expanddiv = $("<div class='container' style='display:none'></div>").appendTo(ul);
                expanddiv.append(sliced);
            }

            if (!objectedItems.length)
                tgt.parent().css("display", "none");
            else
                tgt.parent().css("display", "");

            tgt.trigger("facetsReturned", [objectedItems.length]);
        },
        cleanUp: function () {
            let tgt = $(this.target);
            // Remove AJAX animations from facet widgets
            tgt.children(".synAjaxLoad_animation").remove();
        },
        clickHandler: function (value, noEscape, self) {
            if (!self)
                self = this;
            let meth = self.multivalue ? 'add' : 'set';
            return function () {
                if (self[meth].call(self, value, noEscape))
                    self.doRequest();
                return false;
            }
        },
        set: function (value, noEscape) {
            return this.changeSelection(function () {
                let a = this.manager.store.removeByValue('fq', new RegExp('^-?' + this.field + ':')),
                    b = this.manager.store.addByValue('fq', this.fq(value, false, noEscape));
                return a || b;
            });
        },
        add: function (value, noEscape) {
            return this.changeSelection(function () {
                return this.manager.store.addByValue('fq', this.fq(value, false, noEscape));
            });
        },
        fq: function (value, exclude, noEscape) {
            return (exclude ? '-' : '') + this.field + ':' + (noEscape ? value : AjaxSolr.Parameter.escapeValue(value));
        }
    });
})(jQuery);
